export const SwiperCardData = [
    {
        id: "1",
        title: "James Tan",
        cardImage:"./images/card-1.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.7",
        textContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. ",
        rating: "/images/star-rating.svg"
    },
    {
        id: "2",
        title: "butterfly",
        cardImage:"./images/card-2.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.6",
        textContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. ",
        rating: "/images/star-rating.svg"
    },
    {
        id: "3",
        title: "James Tan",
        cardImage:"./images/card-3.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.8",
        textContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim adipiscing elit. ",
        rating: "/images/star-rating.svg"
    },
    {
        id: "4",
        title: "butterfly",
        cardImage:"./images/card-4.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.5",
        textContent: "Lorem ipsum dolor sit amet, adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim adipiscing elit, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut quis nostrud exercitation. ",
        rating: "/images/star-rating.svg"
    },
    {
        id: "5",
        title: "James Tan",
        cardImage:"./images/card-5.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.2",
        textContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. ",
        rating: "/images/star-rating.svg"
    },
    {
        id: "6",
        title: "James Tan",
        cardImage:"./images/card-6.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.7",
        textContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minimadipiscing elit,aliqua. Ut enim ad minim veniam, quis nostrud exercitation. ",
        rating: "/images/star-rating.svg"
    },
    {
        id: "7",
        title: "James Tan",
        cardImage:"./images/card-7.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.9",
        textContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. ",
        rating: "/images/star-rating.svg"
    },
    {
        id: "8",
        title: "James Tan",
        cardImage:"./images/card-8.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.3",
        textContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. ",
        rating: "/images/star-rating.svg"
    },
    {
        id: "9",
        title: "James Tan",
        cardImage:"./images/card-9.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.4",
        textContent: "Lorem ipsum dolor sit adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim adipiscing elit, sed do eiusmod tempor  Ut enim ad minim amet, consectetur adipiscing labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. ",
        rating: "/images/star-rating.svg"
    },
    {
        id: "10",
        title: "James Tan",
        cardImage:"./images/card-10.jpeg",
        titleLogo: "/images/card-profile.jpg",
        growNo:"0.7",
        textContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. ",
        rating: "/images/star-rating.svg"
    },
    
]